import { graphqlPost } from "api/graphqlClient";
import PageHeader from "components/Layout/PageHeader";
import {
    LiveUpdatesIcon,
    LiveUpdatesIconProps,
} from "containers/Executions/components/LiveUpdatesIcon";
import { Record } from "graphql/generated/graphql";
import { useEffect, useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import { getTypedLowerCase } from "utils/service";
import "./ExecutionsListingPageHeader.scss";

export const ExecutionsListingPageHeader = ({
    isLiveUpdatesEnabled,
    setLiveUpdatesEnabled,
}: LiveUpdatesIconProps) => {
    const { id } = useParams<{ id: string }>();
    const [resourceData, setResourceData] = useState<Record | null>(null);

    useEffect(() => {
        const fetchData = async (id) => {
            if (id) {
                try {
                    const params = {
                        query: `query record($id: String!) {
                                    record(id: $id) {
                                            id
                                            name
                                            record_type
                                        }
                                    }`,
                        variables: {
                            id,
                        },
                        allow_normal: true,
                        allow_deleted: true,
                    };

                    const result = (await graphqlPost(params)) as any;
                    setResourceData(result?.data?.record);
                } catch (error) {
                    console.error(error);
                }
            }
        };
        fetchData(id);
    }, [id]);

    const pageHeaderProps = useMemo(() => {
        const pageHeaderTitle = "Execution live monitor";
        let pageHeaderSubtitle;
        const resourceName = getTypedLowerCase(resourceData?.record_type ?? "");
        if (resourceName === "workspace") {
            pageHeaderSubtitle = `Realtime overview of all current and past executions in your workspace ${resourceData?.name}`;
        } else if (resourceName === "project" || resourceName === "bundle") {
            if (id) {
                pageHeaderSubtitle = `Realtime overview of all current and past executions in ${resourceName} ${resourceData?.name}`;
            } else {
                pageHeaderSubtitle = `Realtime overview of all current and past executions without a project`;
            }
        }
        return {
            title: pageHeaderTitle,
            subtitle: pageHeaderSubtitle,
            showImage: false,
            titleAction: (
                <LiveUpdatesIcon
                    isLiveUpdatesEnabled={isLiveUpdatesEnabled}
                    setLiveUpdatesEnabled={setLiveUpdatesEnabled}
                />
            ),
        };
    }, [
        id,
        isLiveUpdatesEnabled,
        resourceData?.name,
        resourceData?.record_type,
        setLiveUpdatesEnabled,
    ]);

    return <PageHeader {...pageHeaderProps} />;
};
